var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-scene"},[_c('div',{staticClass:"standart-navigation"},[_c('h1',[_vm._v(_vm._s(_vm.$tr('help.title')))])]),_vm._v(" "),(!_vm.managerInfoLoading && _vm.compoundName)?[_c('h2',[_vm._v(_vm._s(_vm.$tr('help.personalManager')))]),_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.compoundName)}})]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }